import { Container } from "./styles";

export default function Side5() {
    return(
        <Container>
            <h2>APTIDÕES</h2>
            <div>
                <h3>MySQL</h3>
                <h3>Javascript</h3>
                <h3>Typescript</h3>
                <h3>HTML5</h3>
                <h3>Java</h3>
                <h3>Bootstrap</h3>
                <h3>C#</h3>
                <h3>Banco de dados</h3>
                <h3>PostgreSQL</h3>
                <h3>Git</h3>
                <h3>Node</h3>
                <h3>Marketing digital</h3>
            </div>
        </Container>
    )
}